module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Staying-Focused.6f14d48d.jpg";